import { useEffect, useRef, useState } from "react";
import { supabase } from "../supabaseClient";

export function useEquipeTempo(entityType, entityId) {
  const [eventos, setEventos] = useState([]);
  const [perfis, setPerfis] = useState({});
  const cache = useRef({});

  const buscarPerfis = async (ids) => {
    const novos = [...new Set(ids)].filter((id) => !cache.current[id]);
    if (!novos.length) return;
    const { data } = await supabase
      .from("profiles")
      .select("id, nome, nickname")
      .in("id", novos);
    (data || []).forEach((p) => { cache.current[p.id] = p; });
    setPerfis({ ...cache.current });
  };

  useEffect(() => {
    if (!entityId) return;
    let ativo = true;
    setEventos([]);

    supabase
      .from("tempo_registros")
      .select("id, user_id, inicio, fim, duracao_segundos, acao")
      .eq("entidade_tipo", entityType)
      .eq("entidade_id", String(entityId))
      .order("fim", { ascending: false })
      .limit(30)
      .then(async ({ data }) => {
        if (!ativo) return;
        const lista = data || [];
        await buscarPerfis(lista.map((r) => r.user_id));
        if (ativo) setEventos(lista);
      });

    const canal = supabase
      .channel(`tempo:${entityType}:${entityId}`)
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table: "tempo_registros", filter: `entidade_id=eq.${entityId}` },
        async (p) => {
          if (p.new.entidade_tipo !== entityType) return;
          await buscarPerfis([p.new.user_id]);
          setEventos((l) => [p.new, ...l].slice(0, 30));
        }
      )
      .subscribe();

    return () => { ativo = false; supabase.removeChannel(canal); };
  }, [entityType, entityId]);

  return { eventos, perfis };
}